import { Box, Grid } from "@mui/material";
import { LoginViewModel } from "./LoginViewModel";
import { CustomImageView } from "../../../component/CustomImageView";
import LoginForm from "./LoginForm";
import useWindowDimensions from "../../../../core/utils/UseWindowDimensions";
import { provideLoginUseCase } from "../../../di/UseCasesModule";

export default function LoginView() {
  const { login } = LoginViewModel(provideLoginUseCase());
  const { width } = useWindowDimensions();

  return (
    <Box>
      <Grid container>
        <Grid
          size={{ xs: 0, sm: 0, md: 6, lg: 8, xl: 8 }}
          sx={{
            width: width > 900 ? "100%" : "0%",
            height: width > 900 ? "100%" : "0%",
          }}
        >
          <Box
            sx={{
              height: "100vh",
              justifyContent: "center",
              display: "flex",
              alignItems: "center",
            }}
          >
            <CustomImageView
              width={"100%"}
              height={"100%"}
              src={require("../../../../assets/images/login_new_bg.jpeg")}
              props={{ borderTopRightRadius: 44, borderBottomRightRadius: 44 }}
            />
          </Box>
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}>
          <LoginForm onSubmit={login} />
        </Grid>
      </Grid>
    </Box>
  );
}
